import React, { useState } from "react";
import ScrollableFeed from 'react-scrollable-feed'

const ParticipantBar = ({ participants, setParticipants }) => {
  const [participantName, setParticipantName] = useState("");
  const handleSubmit = (event) => {

    if(participantName.length !== 0){
        var participantObj = {
            name: participantName,
            color: "#" + Math.floor(Math.random()*16777215).toString(16)
        }
        participants.push(participantObj);
        setParticipants([...participants]);
        setParticipantName("");
        event.preventDefault();
    }
  };

  return (
    <div className="container h-screen pb-2 flex-col flex-1 flex bg-gray-500 ml-2 max-w-xs  text-center shadow-xl overflow-auto">
      <p className="text-3xl text-white">Participant List</p>

      <div className="text-left h-auto max-h-full mx-4 text-white shadow-xl overflow-auto">
        <ScrollableFeed>
        {participants.map((item, index) => (
          <div className={'p-2 rounded mt-2'} style={{backgroundColor: item.color}} key={index}>
            {index + 1}: {item.name}
          </div>
        ))}
        </ScrollableFeed>
      </div>

      <form className="w-full" onSubmit={handleSubmit}>
        <div className='flex flex-col'>
          <input
            type="text"
            placeholder="Enter a participant name"
            className="w-auto rounded p-2 focus:ring-2 focus:ring-blue-600 mx-4 my-2"
            value={participantName}
            onChange={(e) => setParticipantName(e.target.value)}
          />

          <button
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-2 rounded inline-flex mx-4 justify-center w-auto shadow-xl"
            onClick={handleSubmit}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-6 h-6 mr-2"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <span>Add Participant</span>
          </button>
        </div>
      </form>
    </div>
  );
};

export default ParticipantBar;
